import PlanAgeCreditPills, { PlanAgeCreditPillsProps } from './plan-age-credit-pills';

export default function MobileSubHeaders({
  selectedPlanMileage,
  selectedCreditScoreId,
  selectedAgeRangeId,
  selectedAge,
  creditScores,
  ageRanges,
  ageRangePlaceholder,
  creditScorePlaceholder,
  canViewSwap = false,
  canLegacySwap = false,
  mileagePlans,
  planHandleClose,
  planOpen,
  planHandleOpen,
  planError,
  creditOpen,
  creditHandleOpen,
  creditHandleClose,
  creditError,
  hideCreditModal,
  fullstoryEventDelegate,
  alreadyQualified,
}: PlanAgeCreditPillsProps) {
  return (
    <div className="scrollbar-hide flex w-full snap-x snap-mandatory flex-nowrap gap-[8px] overflow-x-auto">
      <PlanAgeCreditPills
        planHandleClose={planHandleClose}
        planOpen={planOpen}
        planHandleOpen={planHandleOpen}
        planError={planError}
        creditHandleClose={creditHandleClose}
        creditOpen={creditOpen}
        creditHandleOpen={creditHandleOpen}
        creditError={creditError}
        creditScores={creditScores}
        ageRanges={ageRanges}
        selectedPlanMileage={selectedPlanMileage}
        selectedCreditScoreId={selectedCreditScoreId}
        selectedAgeRangeId={selectedAgeRangeId}
        selectedAge={selectedAge}
        ageRangePlaceholder={ageRangePlaceholder}
        creditScorePlaceholder={creditScorePlaceholder}
        canViewSwap={canViewSwap}
        canLegacySwap={canLegacySwap}
        mileagePlans={mileagePlans}
        hideCreditModal={hideCreditModal}
        fullstoryEventDelegate={fullstoryEventDelegate}
        alreadyQualified={alreadyQualified}
        pillClassName="bg-flexcar-neutral90 rounded-[8px] text-flexcar-neutral1 inline-flex snap-center"
      />
    </div>
  );
}
